function initToggleValueBlocks() {
  const toggleButtons = document.querySelectorAll('.toggle_value_button');

  toggleButtons?.forEach(function (toggleButton) {
    toggleButton.addEventListener('click', function (e) {
      const toggleParent = this.closest('.toggle_value_parent');

      if (!toggleParent) {
        return;
      }

      const toggleValue = toggleParent.querySelector('.toggle_value');

      if (!toggleValue) {
        return;
      }

      if (toggleValue.classList.contains('show_value')) {
        this.classList.remove('show');
        toggleValue.classList.remove('show_value');
        toggleValue.textContent = toggleValue.getAttribute('data-limit-value') + '...';
      } else {
        this.classList.add('show');
        toggleValue.classList.add('show_value');
        toggleValue.textContent = toggleValue.getAttribute('data-full-value');
      }
    });
  });
}

export { initToggleValueBlocks }